const RELOAD_GUARD_KEY = 'chunk-reload-at'
const RELOAD_GUARD_WINDOW_MS = 10_000

const reloadOnce = () => {
  // Guard against a reload loop: if the fresh build still can't fetch the chunk
  // (e.g. the user is offline), don't keep reloading — let the error surface.
  const lastReloadAt = Number(sessionStorage.getItem(RELOAD_GUARD_KEY))
  if (Number.isFinite(lastReloadAt) && Date.now() - lastReloadAt < RELOAD_GUARD_WINDOW_MS) {
    return
  }

  sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()))
  window.location.reload()
}

// Vite fires `vite:preloadError` when a lazily-imported chunk fails to load —
// typically because a deploy replaced the hashed bundles this long-lived tab was
// pinned to. Reload to pull the current index.html and its chunk map.
const reloadOnChunkError = () => {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    reloadOnce()
  })
}

export default reloadOnChunkError
